function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagAW(props) {
  return /*#__PURE__*/React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUaM3UuT5E2V50mQ4U+X6vnVNtwbP/Tv8cjb8mmk6eyZqIy57OApSuh5jqx/2PQAAAFrSURBVDjLvZC9TsMwFIUt9QVqe2TBlh8gVhbGyMqAxMLCKxgJdUQkalnK0rkVUpG604UFFngCWJjpwsNwf5yAUJtKFfRTbZ977vFNUlF2U4g9BIJzZRkWtw7LQBUTgrXOFcKRqC6hFWjZBF0MhwJkCCfDkcUOLaJ0HCsEGvb4unbQdVQkKGdpgg3zj9WM77cPSCkO2Mnr241dCwfuhvGinm0OvFQP8X1ZP20KzKvPGONgVfEMZa0x5jug7PN9JJaPUik0jVGKl5R9ocyPCWghFpoojekLOPAdBvAOIJVS0ihOGZ6Akr5iipZsMJJiPEHqSTwfy7VwQMI/Oe0MHF3VsjNwMBxJL3XjkvApoAHpJ2Poa+3BxR0crwmaANZi6ptmiqTVFzng4QclKjp9q/JMgMAa0ZTBs/HwEXka0aLT6XOekHeTibNuTv8gsPUddgn09v0V28lET2QZ7a3iooe7wOL3DfZ3Yveb/8oX3a7/NdUGZE4AAAAASUVORK5CYII=",
    alt: "AW"
  }, props));
}